const DEFAULT_API_BASE = "";

const normalizeApiBase = (value) => {
  const base = String(value || "").trim().replace(/\/$/, "");
  if (!base || base === "/api") return "";
  return base;
};

export const API_BASE = normalizeApiBase(
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_BACKEND_URL ||
  DEFAULT_API_BASE
);

export const THEMES = {

  general: {
    name: "TOBE AI",
    primary: "linear-gradient(135deg, #2563eb, #38bdf8)",
    accent: "#60a5fa",
    glass: "rgba(15, 23, 42, 0.72)",
    border: "rgba(148, 163, 184, 0.22)",
  },
  tobe_staff: {
    name: "TOBE Staff",
    primary: "linear-gradient(135deg, #0f766e, #22c55e)",
    accent: "#2dd4bf",
    glass: "rgba(12, 24, 36, 0.76)",
    border: "rgba(45, 212, 191, 0.24)",
  },
  partner: {
    name: "Partner",
    primary: "linear-gradient(135deg, #1d4ed8, #14b8a6)",
    accent: "#38bdf8",
    glass: "rgba(15, 23, 42, 0.74)",
    border: "rgba(56, 189, 248, 0.24)",
  },
};
